import { io } from 'socket.io-client';

const socket = io(
  'https://track.maccez.com',
  {
    transports: ['websocket'],
    autoConnect: false
  }
);

export function conectarSocket() {
  const token =
    localStorage.getItem('token');

  if (!token) {
    return;
  }

  socket.auth = {
    token
  };

  if (!socket.connected) {
    socket.connect();
  }
}

export function desconectarSocket() {
  if (socket.connected) {
    socket.disconnect();
  }
}

export default socket;